<div #portalAdminReactContainer class="admin"></div>